import type { GridReactCommandProps } from '../types';
import LegacyDayTrackedStatsPopup from './components/ShowDayTrackedStatsPopup';
import { parseDayTrackedStatsRow } from './rowAdapter';

export const ShowDayTrackedStatsPopup = ({ row, onClose }: GridReactCommandProps) => {
  const parsed = parseDayTrackedStatsRow(row);

  return (
    <LegacyDayTrackedStatsPopup
      value={parsed.data ? { DetailInfo: parsed.data } : null}
      unavailableMessage={parsed.error}
      closeHandler={onClose}
    />
  );
};

export default ShowDayTrackedStatsPopup;
